export default __webpack_public_path__ + "static/media/bulb.3d092596.svg";